import { useLogout } from '@refinedev/core';
import { useEffect, useRef } from 'react';
import PageLoader from 'src/UI/loader/PageLoader';
import { Logger } from 'src/utils/Logger';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ory } from 'src/providers/authProvider';

export function LogoutPage() {
  const hasLoggedOut = useRef(false);
  const { flagEnabledCustomSettingsFlow } = useFlags();

  const { mutate: logout } = useLogout({
    mutationOptions: {
      onError: async error => {
        Logger.error('Logout failed', error);
        if (flagEnabledCustomSettingsFlow) {
          window.location.replace('/login');
        } else {
          const { data } = await ory.createBrowserLoginFlow({ refresh: true });
          window.location.replace(data.request_url);
        }
      },
    },
  });

  useEffect(() => {
    if (!hasLoggedOut.current) {
      hasLoggedOut.current = true;
      logout();
    }
  }, [logout]);

  return <PageLoader />;
}
